import axios from "axios";

export function checkQueue(url, block, method = 'GET', params = new FormData()) {
    const savedContent = block.cloneNode(true);

    block.replaceChildren();

    block.insertAdjacentHTML('afterbegin', `
        <button type="button" class="btn btn-gray text-nowrap" disabled="">
            <i class="fa fa-spinner left"></i>Запрос в обработке
        </button>
    `);

    const check = async () => {
        let response;
        if (method === 'GET') {
            response = await axios.get(url);
        } else if (method === 'POST') {
            response = await axios.post(url, params);
        } else {
            return;
        }

        if (
            response.status !== 200 || response.data === undefined ||
            response.data.data === undefined || response.data.data.hasActiveJobs === undefined
        ) {
            console.error('Некорректный ответ от сервера.', response);

            block.replaceChildren(...savedContent.childNodes);

            return;
        }

        const data = response.data.data;

        if (data.redirect !== undefined) {
            window.location = data.redirect;
            return;
        }

        if (!data.hasActiveJobs) {
            block.replaceChildren(...savedContent.childNodes);

            return;
        }

        setTimeout(check, 5000)
    };

    check().then();
}
